 
import './CustomLoader.css'
  
  const CustomLoader = ({ width, color }) => <div style={{ width: width, background: `radial-gradient(farthest-side,
     ${color?color:'white'} 94%, #0000) top / 3.5px 3.5px no-repeat, 
  conic-gradient(#0000 30%, ${color?color:'white'})`, }} className="loader-class "></div>
export default CustomLoader